import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
export function ManifestoSection() {
  return <section className="relative isolate overflow-hidden border-t border-white/5 bg-void-900 py-28 md:py-36" data-id="element-144" data-mp="58f1yf1l0l2z">
      <div className="grain pointer-events-none absolute inset-0 opacity-70" aria-hidden="true" data-id="element-145" data-mp="a55j75p4hmpz" />
      <div className="neon-grid pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-146" data-mp="ezjhpgz309yv" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-500/[0.14] blur-3xl" aria-hidden="true" data-id="element-147" data-mp="j14smws22e6f" />

      <div className="relative mx-auto max-w-3xl px-6 text-center" data-id="element-148" data-mp="svdckw30sysz">
        <Reveal data-id="element-149" data-mp="xvsu7zuc4sgr">
          <h2 className="font-display text-4xl font-light leading-[1.1] text-bone-50 sm:text-5xl md:text-6xl" data-id="element-150" data-mp="xu85wrym65rc">
            No naciste para sobrevivir.{' '}
            <em className="neon-text not-italic text-gold-400" data-id="element-151" data-mp="2zop9jyva2h6o">Naciste para recordar.</em>
          </h2>
        </Reveal>

        <Reveal delay={0.08} data-id="element-152" data-mp="2n7xuxtjrwghi">
          <p className="mx-auto mt-9 max-w-2xl text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-153" data-mp="2n8671j82nhrn">
            El miedo te dijo que eras pequeño. La rutina te convenció de que esto era todo. La
            programación te susurró que no preguntaras.
          </p>
        </Reveal>

        <Reveal delay={0.14} data-id="element-154" data-mp="28fdwh67kix6e">
          <p className="mt-6 font-display text-2xl italic text-bone-100 sm:text-3xl" data-id="element-155" data-mp="364z1hisz6onk">
            Pero algo dentro de ti siempre supo más.
          </p>
        </Reveal>

        <Reveal delay={0.2} data-id="element-156" data-mp="3141l9brj04op">
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-157" data-mp="2w6rp7d9msurw">
            Tu alma vino a jugar este juego — no a perderse en él. Y despertar no es huir de la
            realidad… es atreverte a mirarla de verdad.
          </p>
        </Reveal>

        <Reveal delay={0.26} data-id="element-158" data-mp="1gqar1n3y3gs6">
          <CTAButton label="¿Estás listo para jugar?" className="mt-12" data-id="element-159" data-mp="1gq1b6scm6q07" />
        </Reveal>
      </div>
    </section>;
}